import React, { useMemo, useEffect, useState, useRef } from "react";
import { BiMailSend, BiPencil, BiTimer, BiUser, BiDotsVerticalRounded, BiPaperclip, BiBook, BiStar, BiX } from "react-icons/bi";
import "../../../components/Dashboard/Agency/PropertiesAgecny/propertiesagency.css";
import { getserviceticketdetails, replyconversation, assignedTo, updatebasicserviceticketdetails, SearchProperty, FilePath, forwardconversation, addconversationnote } from "../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner, uploadToS3WithSpinner } from "../../../Utilities/client";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import SubNav from "../../navbar/subNav";
import "./serviceManagement.css";
import { Select, Dropdown, Menu, Button, Input, Tabs, message, Spin } from "antd";
import { ActionStatus } from "../../../Utilities/enum";
import ReactQuill from "react-quill";
import axios from "axios";
import { DownloadOutlined, DeleteOutlined, PaperClipOutlined } from "@ant-design/icons";
import debounce from "lodash/debounce";
import ToastAlert from "../../../components/CommonSection/ToastAlert/ToastAlert";
import CustomModal from "../../input-components/Modal";
import EmailContent from "../../input-components/Email";
import CustomActivity from "../../input-components/customActivity";
import { CgMailForward,CgMailReply  } from "react-icons/cg";

const { TabPane } = Tabs;

const ServiceManagement = ({ }) => {
    let selectedFile
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const [showRequesterDetails, setShowRequesterDetails] = useState(false);
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [ticketDetails, setTicketDetails] = useState(null);
    const [activeReply, setActiveReply] = useState(null); // Track which conversation is active for reply
    const [replyContent, setReplyContent] = useState(""); // Stores ReactQuill content
    const [dpdata, setDpdata] = useState([]);
    const [conversationFiles, setConversationFiles] = useState({});
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState([]);
    const [searchValue, setSearchValues] = useState("");
    const [addressLabel, setAddressLabel] = useState("");
    const [ccAddress, setCcAddress] = useState("");
    const [bccAddress, setBccAddress] = useState("");
    const [formData, setFormData] = useState({
        Id: "",
        Source: "",
        AssignTo: "",
        Status: "",
        Urgency: "",
        Impact: "",
        Priority: "",
    });
    var url = new URL(window.location.href);
    var ticketUniqueId = url.searchParams.get("ticketUniqueId");
    var isNew = url.searchParams.get("isNew"); ticketId
    var ticketId = url.searchParams.get("ticketId");

    const [imageModalVisible, setImageModalVisible] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [isForwarding, setIsForwarding] = useState(false);
    const [forwardDetails, setForwardDetails] = useState({
        toEmail: "",
        subject: "",
        message: "",
        attachments: [],
        conversationId: null,
    });
    const [isAddingNote, setIsAddingNote] = useState(false);
    const [noteContent, setNoteContent] = useState(""); // Stores the note content
    const noteFileInputRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const primaryDocumentRef = useRef(null);
    const fetchRef = useRef(0);
    const ToastRef = useRef();
    const replySectionRef = useRef(null);
    const [noteAttachments, setNoteAttachments] = useState([]);
    const [showCc, setShowCc] = useState(false);
    const [showBcc, setShowBcc] = useState(false);


    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                    reportData(parsedData.agencyUniqueID);
                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, [userId]);

    const reportData = (agencyUID) => {
        const apiUrl = assignedTo;
        const baseUrl = apiUrl + "?agencyUID=" + agencyUID;
        axios.get(baseUrl).then((response) => {
            if (response.data.object) setDpdata(response.data.object);
        });
    };


    useEffect(() => {
        if (userId) fetchTicketDetails();
    }, [userId]);

    const fetchTicketDetails = () => {
        const baseUrl = getserviceticketdetails + `?TicketUniqueId=${ticketUniqueId}&isNew=${isNew}`;
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "get")
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    setTicketDetails(response.object);
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        Impact: response.object?.impact || "",
                        Source: response.object?.source || "",
                        AssignTo: response.object?.assignTo?.toString() || "",
                        Status: response.object?.status || "",
                        Urgency: response.object?.urgency || "",
                        Priority: response.object?.priority || ""
                    }));
                    setAddressLabel(response.object.propertyAddress)
                    setSearchValues(response.object.propertyId)

                } else {
                    ToastRef.current.notify(["error", response.message]);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const submitreplyconversation = (conversation) => {
        if (!conversation || !replyContent) {
            message.error("Reply content cannot be empty!");
            return;
        }

        const baseUrl = replyconversation;

        const plainTextDescription = replyContent.replace(/<[^>]+>/g, '');

        const attachments = (conversationFiles[conversation.id] || []).map(file => ({
            FileName: file.name,
            FileChecksum: file.src
        }));

        let formdata = {
            TicketId: ticketDetails?.id || "",
            Description: replyContent,
            RecipientEmail: conversation.requesterEmail,
            RecipientName: conversation.requesterName,
            TicketConversationId: conversation.id,
            Attachments: attachments,
            CCAddress: ccAddress,
            BCAddress: bccAddress
        };

        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", formdata)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    fetchTicketDetails();
                    setActiveReply(null);
                    setReplyContent("")
                    fetchTicketDetails()
                    setBccAddress("")
                    setCcAddress("")
                    ToastRef.current.notify(["success", response.message]);

                } else {
                    ToastRef.current.notify(["error", response.message]);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const submitProperties = () => {
        const baseUrl = updatebasicserviceticketdetails;
        let formdata = {
            Id: ticketDetails?.id || "",
            Source: formData.Source,
            AssignTo: formData.AssignTo,
            Status: formData.Status,
            Urgency: formData.Urgency,
            Impact: formData.Impact,
            Priority: formData.Priority,
            PropertyId: searchValue
        };

        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", formdata)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    fetchTicketDetails()
                    ToastRef.current.notify(["success", response.message]);

                } else {
                    ToastRef.current.notify(["error", response.message]);

                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };


    const priorityOptions = [
        { label: "Low", value: 3 },
        { label: "Medium", value: 2 },
        { label: "High", value: 1 },
        { label: "Urgent", value: 1 }

    ];

    const statusOptions = [
        { label: "Open", value: 1 },
        { label: "Pending", value: 2 },
        { label: "Resolved", value: 3 },
        { label: "Closed", value: 4 }
    ];

    const sourceOptions = [
        { label: "Phone", value: 1 },
        { label: "Email", value: 2 },
        { label: "Portal", value: 3 },
        { label: "Chat", value: 4 },
        { label: "Feedback Widget", value: 5 },
        { label: "Yammer", value: 6 },
        { label: "AWS CloudWatch", value: 7 },
        { label: "PagerDuty", value: 8 },
        { label: "Walk-up", value: 9 },
        { label: "Slack", value: 10 },
        { label: "Workplace", value: 11 },
        { label: "MS Teams", value: 12 },
    ];

    const menu = (
        <Menu>
            <Menu.Item key="1">Edit</Menu.Item>
            <Menu.Item key="2">Delete</Menu.Item>
        </Menu>
    );


    // Handle file input change
    const handleInputChangeFile = (e, id) => {
        const files = e.target.files;
        handleFileChange(files, id);
    };

    // Process each file and upload
    const handleFileChange = async (files, id) => {
        setLoading(true);
        for (let i = 0; i < files.length; i++) {
            await handleUpload(files[i], id);
        }
        setLoading(false);
    };

    // Upload file to server (S3 or backend)
    const handleUpload = async (selectedFile, conversationId) => {
        await uploadToS3WithSpinner(
            showSpinner,
            hideSpinner,
            "servicemanagement/",
            `servicemanagement`,
            selectedFile
        ).then((returnData) => {
            if (returnData.status === 1) {
                console.log(returnData, 'returnData')
                const transformedItem = {
                    id: Math.floor(Math.random() * 1000000),
                    src: returnData.Key, // Assuming returnData.Key is a valid file URL
                    name: selectedFile.name,

                };
                setConversationFiles((prev) => ({
                    ...prev,
                    [conversationId]: [...(prev[conversationId] || []), transformedItem],
                })); message.success("File uploaded successfully");
            } else {
                message.error("Error uploading file. Please try again.");
            }
        });
    };

    // Handle file selection click
    const handleFileUploader = () => {
        primaryDocumentRef.current.click();
    };

    const handleNoteFileUploader = () => {
        noteFileInputRef.current.click();
    }

    // Remove an uploaded image
    const handleRemoveFile = (conversationId, fileId) => {
        setConversationFiles((prev) => ({
            ...prev,
            [conversationId]: prev[conversationId].filter((file) => file.id !== fileId),
        }));
    };


    const debounceFetcher = useMemo(() => {
        const loadOptions = (value) => {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            setOptions([]);
            setFetching(true);
            const baseUrl = SearchProperty;
            const data = {
                Search: value,
                RecordsPerPage: 10,
                PageNo: 1,
            };

            makeRequestWithSpinner(
                showSpinner,
                hideSpinner,
                baseUrl,
                "post",
                data,
                "",
                false
            )
                .then((response) => {
                    if (response.status === 1) {
                        let landingPageListData = response.list;

                        // Transform data to match Select options
                        const transformedData = landingPageListData.map((item) => ({
                            value: item.id,
                            label: item.name,
                        }));

                        // Update options and fetching state
                        if (fetchId === fetchRef.current) {
                            setOptions(transformedData);
                            setFetching(false);
                        }
                    } else {
                        setFetching(false);
                    }
                })
                .catch((error) => {
                    setFetching(false);
                });
        };
        return debounce(loadOptions, 800);
    }, []);

    const handleSearchProperty = (value) => {
        debounceFetcher(value);
        setSearchValues(value.value);
        setAddressLabel(value.label)
    };

    const handleClearProperty = () => {
        setSearchValues("");
    };

    console.log(conversationFiles)

    const handleDownload = (fileUrl, fileName) => {
        const downloadUrl = `${FilePath + fileUrl}`;

        // Fetch the file as a blob
        fetch(downloadUrl)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                console.error("Error downloading file:", error);
                message.error("Error downloading file. Please try again.");
            });
    };


    const openImageModal = (fileUrl) => {
        setSelectedImage(`${FilePath + fileUrl}`);
        setImageModalVisible(true);
    };

    const handleForward = (conversation) => {
        const formattedMessage = `
    ${conversation.body}
        `.replace(/\n/g, '<br />'); // Replace newlines with HTML breaks

        setForwardDetails({
            toEmail: "",
            subject: `Fwd: ${conversation.subject}`,
            message: formattedMessage,
            attachments: conversation.attachments || [],
            conversationId: conversation.id,
        });

        setIsForwarding(true);
        setBccAddress("")
        setCcAddress("")
    };


    const submitForwardMessage = () => {
        if (!forwardDetails.toEmail) {
            message.error("Recipient email is required!");
            return;
        }

        const plainTextDescription = forwardDetails.message.replace(/<[^>]+>/g, '');

        const baseUrl = forwardconversation; // Use the same API for sending emails
        let formData = {
            TicketId: ticketDetails?.id || "",
            Comment: plainTextDescription,
            EmailAddress: [forwardDetails.toEmail],
            // Subject: forwardDetails.subject,
            ConversationId: forwardDetails.conversationId,
            // Attachments: forwardDetails.attachments.map((file) => ({
            //     FileName: file.fileName,
            //     FileChecksum: file.fileChecksum,
            // })),
            CCAddress : ccAddress,
            BCAddress : bccAddress
        };

        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", formData)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    message.success("Message forwarded successfully!");
                    setIsForwarding(false);
                    fetchTicketDetails(); // Refresh conversation
                } else {
                    message.error(response.message);
                }
            })
            .catch((error) => {
                console.error("Error forwarding message:", error);
                message.error("Failed to forward message.");
            });
    };

    const handleRemoveForwardAttachment = (index) => {
        setForwardDetails(prevDetails => ({
            ...prevDetails,
            attachments: prevDetails.attachments.filter((_, i) => i !== index)
        }));
    };



    const submitNote = async () => {
        if (!noteContent.trim()) {
            message.error("Note content cannot be empty!");
            return;
        }

        // Prepare Data for API
        const formData = {
            TicketId: ticketDetails?.id || "",
            Note: noteContent.replace(/<[^>]+>/g, ''), // Strip HTML tags
            NotifyName: "",
            Attachments: noteAttachments.map(file => ({
                FileName: file.name,
                FileChecksum: file.fileChecksum
            }))
        };

        makeRequestWithSpinner(showSpinner, hideSpinner, addconversationnote, "post", formData)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    fetchTicketDetails(); // Refresh conversation list
                    setIsAddingNote(false);
                    setNoteContent("");
                    setNoteAttachments([]);
                    message.success("Note added successfully!");
                } else {
                    message.error(response.message);
                }
            })
            .catch((error) => {
                console.error("Error adding note:", error);
                message.error("Failed to add note.");
            });
    };


    const handleInputChangeFile1 = (e) => {
        debugger
        const files = e.target.files;
        handleFileChange1(files);
    };


    const handleFileChange1 = async (files, id) => {
        debugger
        setLoading(true);
        for (let i = 0; i < files.length; i++) {
            await handleUpload1(files[i], id);
        }
        setLoading(false);
    };

    // Upload file to server (S3 or backend)
    const handleUpload1 = async (selectedFile, conversationId) => {
        debugger
        await uploadToS3WithSpinner(
            showSpinner,
            hideSpinner,
            "servicemanagement/",
            `servicemanagement`,
            selectedFile
        ).then((returnData) => {
            if (returnData.status === 1) {
                console.log(returnData, 'returnData')
                const transformedItem = {
                    id: Math.floor(Math.random() * 1000000),
                    fileChecksum: returnData.Key, // Assuming returnData.Key is a valid file URL
                    name: selectedFile.name,
                };
                setNoteAttachments((prev) => [...prev, transformedItem]);
                message.success("File uploaded successfully");
            } else {
                message.error("Error uploading file. Please try again.");
            }
        });
    };

    const handleRemoveFile1 = (index) => {
        setNoteAttachments((prev) => prev.filter((_, i) => i !== index));
    };


    return (
        <div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                    <SubNav title={"Tickets List - New & Open Tickets"} goback={true} extraData={true} />
                    <div className="material-work-desk-new bg-white m-3">
                        <ToastAlert ref={ToastRef} />
                        <div className="main-contentser">
                            <div className="left-section scrollable-section">
                                <div className="header-section">
                                    <div className="header-info">
                                        <div className="d-flex">
                                            <div className="icon-container">
                                                <BiMailSend size={40} color="#00b894" />
                                            </div>
                                            <div className="ml-2">
                                                <div className="maintitle mb-2">{ticketDetails?.subject} <span>{`- #${ticketDetails?.ticketNo}`}</span></div>
                                                <div className="mb-1" style={{ fontSize: '14px', color: 'gray' }}>
                                                    <strong style={{ color: "#2196f3", fontSize: '16px' }}>{ticketDetails?.requesterName}</strong> {new Date(ticketDetails?.createdAt).toLocaleString()}<BiMailSend />
                                                </div>
                                                <div style={{ fontSize: '14px', color: 'gray' }}>To: {ticketDetails?.recipientEmail}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <Tabs defaultActiveKey="1" className="custom-tabs sticky-tabs">
                                    <TabPane tab="Details" key="1">
                                        {ticketDetails?.serviceTicketConversationDetails && ticketDetails.serviceTicketConversationDetails.length > 0 && (
                                            <>
                                                {/* First Conversation - "Description" */}
                                                <div className="conversation-section mt-3">
                                                    <h3>Description</h3>
                                                    <div className="conversation-desp">
                                                        <div className="conversation-actions">
                                                            {ticketDetails.serviceTicketConversationDetails[0].requesterEmail !== "developer@forealproperty.com.au" ?<div className="action-icon"> <CgMailReply  style={{fontSize:'20px'}} title="replay"  onClick={() => {
                                                                setActiveReply(activeReply === 0 ? null : 0);
                                                                setTimeout(() => {
                                                                    replySectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                                                }, 100);
                                                            }} /> reply</div>: null}
                                                            <div className="action-icon"><CgMailForward style={{fontSize:'20px'}} title="forward"  onClick={() => handleForward(ticketDetails.serviceTicketConversationDetails[0])} />forward</div>
                                                            {/* <Dropdown overlay={<Menu><Menu.Item key="1">Edit</Menu.Item><Menu.Item key="2">Delete</Menu.Item></Menu>} trigger={["click"]}>
                                                                <BiDotsVerticalRounded title="action" className="action-icon" />
                                                            </Dropdown> */}
                                                        </div>
                                                        {/* <div  className="html-content email-content" dangerouslySetInnerHTML={{ __html: ticketDetails.serviceTicketConversationDetails[0].body}}></div> */}
                                                        <EmailContent content={ticketDetails.serviceTicketConversationDetails[0].body} />

                                                        {ticketDetails.serviceTicketConversationDetails[0].attachments && ticketDetails.serviceTicketConversationDetails[0].attachments.length > 0 && (
                                                            <div className="attachments-section">
                                                                <div className="uploaded-files-container">
                                                                    {ticketDetails.serviceTicketConversationDetails[0].attachments.map((file, fileIndex) => (
                                                                        <div key={fileIndex} className="file-box">
                                                                            <PaperClipOutlined className="file-icon" />
                                                                            <div className="file-info">
                                                                                <span

                                                                                    className="file-link" onClick={() => openImageModal(file.fileChecksum)}>
                                                                                    {file.fileName}
                                                                                </span>
                                                                            </div>
                                                                            <DownloadOutlined onClick={() => handleDownload(file.fileChecksum, file.fileName)} />
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {activeReply === 0 && (
                                                            <div className="reply-section" ref={replySectionRef}>
                                                                <div className="reply-header">
                                                                    <span>From:</span> <strong>{ticketDetails.serviceTicketConversationDetails[0].requesterName} &lt;{ticketDetails.serviceTicketConversationDetails[0].requesterEmail}&gt;</strong>
                                                                </div>
                                                                <div className="reply-to">
                                                                    <div className="d-flex justify-content-between">
                                                                        <label>Reply to:</label>
                                                                        <div>
                                                                            <label onClick={() => setShowCc(true)} style={{ cursor: 'pointer', marginRight: "10px" }}>Cc</label>
                                                                            <label onClick={() => setShowBcc(true)} style={{ cursor: 'pointer' }}>Bcc</label>
                                                                        </div>
                                                                    </div>
                                                                    <Input defaultValue={ticketDetails.serviceTicketConversationDetails[0].requesterEmail} />
                                                                </div>
                                                                {showCc && (
                                                                    <div className="reply-to d-flex align-items-center">
                                                                        <Input
                                                                            placeholder="Cc:"
                                                                            value={ccAddress}
                                                                            onChange={(e) => setCcAddress(e.target.value)}
                                                                        />
                                                                        <BiX style={{ cursor: 'pointer', marginLeft: '10px' }}
                                                                            onClick={() => { setCcAddress(""); setShowCc(false); }}
                                                                        />
                                                                    </div>
                                                                )}

                                                                {/* Bcc Field */}
                                                                {showBcc && (
                                                                    <div className="reply-to d-flex align-items-center">
                                                                        <Input
                                                                            placeholder="Bcc:"
                                                                            value={bccAddress}
                                                                            onChange={(e) => setBccAddress(e.target.value)}
                                                                        />
                                                                        <BiX style={{ cursor: 'pointer', marginLeft: '10px' }}
                                                                            onClick={() => { setBccAddress(""); setShowBcc(false); }}
                                                                        />
                                                                    </div>
                                                                )}
                                                                <ReactQuill theme="snow" value={replyContent} onChange={setReplyContent} />
                                                                <div className="reply-footer">
                                                                    <div style={{ width: '100%' }}>
                                                                        <input
                                                                            ref={primaryDocumentRef}
                                                                            type="file"
                                                                            className="upload-input"
                                                                            name="upload"
                                                                            multiple
                                                                            onChange={(e) => handleInputChangeFile(e, ticketDetails.serviceTicketConversationDetails[0].id)}
                                                                            hidden
                                                                        />
                                                                        {conversationFiles[ticketDetails.serviceTicketConversationDetails[0].id]?.length > 0 && (
                                                                            <div className="attachments-section">
                                                                                <div className="uploaded-files-container">
                                                                                    {conversationFiles[ticketDetails.serviceTicketConversationDetails[0].id]?.map((file) => (
                                                                                        <div key={file.id} className="file-box">
                                                                                            <PaperClipOutlined className="file-icon" />

                                                                                            <div className="file-info">
                                                                                                <span className="file-name">{file.name}</span>
                                                                                            </div>
                                                                                            <DeleteOutlined onClick={() => handleRemoveFile(ticketDetails.serviceTicketConversationDetails[0].id, file.id)} />
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                            <div>
                                                                                <BiPaperclip className="footer-icon" onClick={handleFileUploader} />
                                                                                <BiBook className="footer-icon" />
                                                                                <BiStar className="footer-icon" />
                                                                            </div>
                                                                            <div>
                                                                                <Button className="cancel-btn" onClick={() => setActiveReply(null)}>Cancel</Button>
                                                                                <Button className="send-btn" onClick={() => submitreplyconversation(ticketDetails.serviceTicketConversationDetails[0])}>Send</Button>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Remaining Conversations - "Conversations" */}
                                                {ticketDetails.serviceTicketConversationDetails.length > 1 && (
                                                    <div className="conversation-section mt-3">
                                                        <h3>Conversations</h3>
                                                        {ticketDetails.serviceTicketConversationDetails.slice(1).map((conv, index) => (
                                                            <div key={index + 1} className={conv.isNote ? "conversation-desp mt-2" : `${(index + 1) % 2 === 0 ? 'conversation-even' : 'conversation-odd'}`}>
                                                                <div className="conversation-actions">
                                                                    {conv.requesterEmail !== "developer@forealproperty.com.au" ? <div className="action-icon"> <CgMailReply  style={{fontSize:'20px'}} title="replay" onClick={() => {
                                                                        setActiveReply(activeReply === index + 1 ? null : index + 1); setTimeout(() => {
                                                                            replySectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                                                        }, 100);
                                                                    }} />reply</div> : null}
                                                                   <div className="action-icon"> <CgMailForward style={{fontSize:'20px'}} title="forward" onClick={() => handleForward(conv)} />forward</div>
                                                                    {/* <Dropdown overlay={<Menu><Menu.Item key="1">Edit</Menu.Item><Menu.Item key="2">Delete</Menu.Item></Menu>} trigger={["click"]}>
                                                                        <BiDotsVerticalRounded className="action-icon" />
                                                                    </Dropdown> */}
                                                                </div>
                                                                {!conv.isNote ? <p className="mb-0"><strong>From:</strong> {conv.requesterName} ({conv.requesterEmail})</p> : <p className="mb-0"><strong>{conv.requesterName} </strong></p>}
                                                                {!conv.isNote ? <p className="mb-0"><strong>To:</strong> {conv.recipientName} ({conv.recipientEmail})</p> : <p>{conv.requesterEmail}</p>}
                                                                {!conv.isNote && conv.ccAddress ? <p className="mb-0" style={{color:'gray'}}><strong>Cc:</strong> {conv.ccAddress}</p> : null}
                                                                {!conv.isNote && conv.bcAddress ? <p style={{color:'gray'}}><strong>Bcc:</strong> {conv.bcAddress}</p> : null}
                                                                <EmailContent className="mt-2" content={conv.body} />

                                                                {conv.attachments && conv.attachments.length > 0 && (
                                                                    <div className="attachments-section">
                                                                        <div className="uploaded-files-container">
                                                                            {conv.attachments.map((file, fileIndex) => (
                                                                                <div key={fileIndex} className="file-box">
                                                                                    <PaperClipOutlined className="file-icon" />
                                                                                    <div className="file-info">
                                                                                        <span
                                                                                            className="file-link" onClick={() => openImageModal(file.fileChecksum)}>
                                                                                            {file.fileName}
                                                                                        </span>
                                                                                    </div>
                                                                                    <DownloadOutlined onClick={() => handleDownload(file.fileChecksum, file.fileName)} />
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {activeReply === index + 1 && (
                                                                    <div className="reply-section" ref={replySectionRef}>
                                                                        <div className="reply-header">
                                                                            <span>From:</span> <strong>{conv.requesterName} &lt;{conv.requesterEmail}&gt;</strong>
                                                                        </div>
                                                                        <div className="reply-to">
                                                                            <div className="d-flex justify-content-between">
                                                                                <label>Reply to:</label>
                                                                                <div>
                                                                                    <label onClick={() => setShowCc(true)} style={{ cursor: 'pointer', marginRight: "10px" }}>Cc</label>
                                                                                    <label onClick={() => setShowBcc(true)} style={{ cursor: 'pointer' }}>Bcc</label>
                                                                                </div>
                                                                            </div>
                                                                            <Input defaultValue={conv.requesterEmail} />
                                                                        </div>
                                                                        {showCc && (
                                                                            <div className="reply-to d-flex align-items-center">
                                                                                <Input
                                                                                    placeholder="Cc:"
                                                                                    value={ccAddress}
                                                                                    onChange={(e) => setCcAddress(e.target.value)}
                                                                                />
                                                                                <BiX style={{ cursor: 'pointer', marginLeft: '10px' }}
                                                                                    onClick={() => { setCcAddress(""); setShowCc(false); }}
                                                                                />
                                                                            </div>
                                                                        )}

                                                                        {/* Bcc Field */}
                                                                        {showBcc && (
                                                                            <div className="reply-to d-flex align-items-center">
                                                                                <Input
                                                                                    placeholder="Bcc:"
                                                                                    value={bccAddress}
                                                                                    onChange={(e) => setBccAddress(e.target.value)}
                                                                                />
                                                                                <BiX style={{ cursor: 'pointer', marginLeft: '10px' }}
                                                                                    onClick={() => { setBccAddress(""); setShowBcc(false); }}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                        <ReactQuill theme="snow" value={replyContent} onChange={setReplyContent} />
                                                                        <div className="reply-footer">
                                                                            <div style={{ width: '100%' }}>
                                                                                <input
                                                                                    ref={primaryDocumentRef}
                                                                                    type="file"
                                                                                    className="upload-input"
                                                                                    name="upload"
                                                                                    multiple
                                                                                    onChange={(e) => handleInputChangeFile(e, conv.id)}
                                                                                    hidden
                                                                                />
                                                                                {conversationFiles[conv.id]?.length > 0 && (
                                                                                    <div className="attachments-section">
                                                                                        <div className="uploaded-files-container">
                                                                                            {conversationFiles[conv.id]?.map((file) => (
                                                                                                <div key={file.id} className="file-box">
                                                                                                    <PaperClipOutlined className="file-icon" />

                                                                                                    <div className="file-info">
                                                                                                        <span className="file-name">{file.name}</span>
                                                                                                    </div>
                                                                                                    <DeleteOutlined onClick={() => handleRemoveFile(conv.id, file.id)} />
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                                    <div>
                                                                                        <BiPaperclip className="footer-icon" onClick={handleFileUploader} />
                                                                                        <BiBook className="footer-icon" />
                                                                                        <BiStar className="footer-icon" />
                                                                                    </div>
                                                                                    <div>
                                                                                        <Button className="cancel-btn" onClick={() => setActiveReply(null)}>Cancel</Button>
                                                                                        <Button className="send-btn" onClick={() => submitreplyconversation(conv)}>Send</Button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}


                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </>
                                        )}
                                        <div>
                                            <div onClick={() => setIsAddingNote(true)} className="addnote">Add Note</div>
                                        </div>
                                    </TabPane>

                                    <TabPane tab="Activities" key="4">
                                        <div className="p-5">
                                            <CustomActivity ModuleType={19} RecordId={ticketId} />
                                        </div>
                                    </TabPane>

                                </Tabs>
                                <CustomModal
                                    title="Image Preview"
                                    visible={imageModalVisible}
                                    onCancel={() => setImageModalVisible(false)}
                                    footer={null}
                                    modalData={
                                        selectedImage ? <img src={selectedImage} alt="Preview" style={{ width: "100%", maxHeight: "500px" }} /> : null
                                    }
                                />
                                {isForwarding && (
                                    <CustomModal
                                        title="Forward Message"
                                        width={700}
                                        visible={isForwarding}
                                        onCancel={() => setIsForwarding(false)}
                                        footer={[
                                            <Button className="mt-3" key="cancel" onClick={() => setIsForwarding(false)}>Cancel</Button>,
                                            <Button className="mt-3" key="forward" type="primary" onClick={submitForwardMessage}>Forward</Button>,
                                        ]}
                                        modalData={
                                            <div>
                                                <div className="form-group">
                                                    <div className="d-flex justify-content-between">
                                                        <label>To:</label>
                                                        <div className="d-flex">
                                                            <label onClick={() => setShowCc(true)} style={{ cursor: 'pointer', marginRight: "10px" }}>Cc</label>
                                                            <label onClick={() => setShowBcc(true)} style={{ cursor: 'pointer' }}>Bcc</label>
                                                        </div>
                                                    </div>
                                                    <Input
                                                        placeholder="Enter recipient email"
                                                        value={forwardDetails.toEmail}
                                                        onChange={(e) => setForwardDetails({ ...forwardDetails, toEmail: e.target.value })}
                                                    />
                                                </div>
                                                {showCc && (
                                                    <div className="reply-to d-flex align-items-center">
                                                        <Input
                                                            placeholder="Cc:"
                                                            value={ccAddress}
                                                            onChange={(e) => setCcAddress(e.target.value)}
                                                        />
                                                        <BiX style={{ cursor: 'pointer', marginLeft: '10px' }}
                                                            onClick={() => { setCcAddress(""); setShowCc(false); }}
                                                        />
                                                    </div>
                                                )}

                                                {/* Bcc Field */}
                                                {showBcc && (
                                                    <div className="reply-to d-flex align-items-center">
                                                        <Input
                                                            placeholder="Bcc:"
                                                            value={bccAddress}
                                                            onChange={(e) => setBccAddress(e.target.value)}
                                                        />
                                                        <BiX style={{ cursor: 'pointer', marginLeft: '10px' }}
                                                            onClick={() => { setBccAddress(""); setShowBcc(false); }}
                                                        />
                                                    </div>
                                                )}
                                                <div className="form-group">
                                                    <label>Subject:</label>
                                                    <Input
                                                        placeholder="Subject"
                                                        value={forwardDetails.subject}
                                                        onChange={(e) => setForwardDetails({ ...forwardDetails, subject: e.target.value })}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Message:</label>
                                                    <ReactQuill
                                                        theme="snow"
                                                        value={forwardDetails.message}
                                                        onChange={(value) => setForwardDetails({ ...forwardDetails, message: value })}
                                                    />
                                                </div>
                                                {/* {forwardDetails.attachments.length > 0 && (
                                                                                    <div className="attachments-preview">
                                                                                        <h6>Attachments:</h6>
                                                                                        {forwardDetails.attachments.map((file, index) => (
                                                                                            <div key={index} className="file-box">
                                                                                                <PaperClipOutlined /> {file.fileName}
                                                                                                <DeleteOutlined
                                                                                                    className="delete-icon1"
                                                                                                    title="Delete Attachment"
                                                                                                    onClick={() => handleRemoveForwardAttachment(index)}
                                                                                                />
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                )} */}
                                            </div>
                                        }
                                    />
                                )}

                                {isAddingNote && (
                                    <CustomModal
                                        title="Add Note"
                                        width={700}
                                        visible={isAddingNote}
                                        onCancel={() => setIsAddingNote(false)}
                                        footer={[
                                            <Button className="mt-3" key="cancel" onClick={() => setIsAddingNote(false)}>Cancel</Button>,
                                            <Button className="mt-3" key="add" type="primary" onClick={() => submitNote()}>Add Note</Button>,
                                        ]}
                                        modalData={
                                            <div>
                                                {/* Note Content */}
                                                <div className="form-group">
                                                    <label>Note Content:</label>
                                                    <ReactQuill
                                                        theme="snow"
                                                        value={noteContent}
                                                        onChange={setNoteContent}
                                                    />
                                                </div>

                                                {/* File Upload Section */}
                                                <div className="form-group">
                                                    <label>Attachments:</label>
                                                    <input
                                                        ref={noteFileInputRef}
                                                        type="file"
                                                        className="upload-input"
                                                        name="upload"
                                                        multiple
                                                        onChange={(e) => handleInputChangeFile1(e)}
                                                        hidden
                                                    />
                                                    <Button icon={<PaperClipOutlined />} onClick={handleNoteFileUploader}>
                                                        Attach Files
                                                    </Button>

                                                    {/* Display Uploaded Files */}
                                                    {noteAttachments.length > 0 && (
                                                        <div className="attachments-preview">
                                                            {noteAttachments.map((file, index) => (
                                                                <div key={index} className="file-box">
                                                                    <PaperClipOutlined className="file-icon" />
                                                                    <span className="file-name">{file.name} </span>
                                                                    <DeleteOutlined

                                                                        onClick={() => handleRemoveFile1(index)}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        }
                                    />
                                )}



                            </div>

                            <div className="right-section">
                                <div className="status-box">
                                    <div className="openStatus">Open</div>
                                    <div style={{ color: 'gray' }}>Priority</div>
                                    <div className="priority-section">
                                        <span className="priority-indicator"></span>
                                        <span className="priority-text">Low</span>
                                    </div>
                                    <div className="resolution-section d-flex">
                                        <div>
                                            <div style={{ color: 'gray' }}>Resolution due <BiPencil className="edit-icon" /></div>
                                            <div >by Mon, 14 Oct 2024, 2:08 AM</div>
                                        </div>
                                        <div className="due-timer">
                                            <BiTimer className="timer-icon" /> - 3mon 3w
                                        </div>
                                    </div>
                                </div>

                                <div className="requester-info">
                                    <h3><BiUser /> Requester Information</h3>
                                    <p className="requester-name"><strong>{ticketDetails?.requesterName}</strong></p>
                                    <button onClick={() => setShowRequesterDetails(!showRequesterDetails)} className="view-more">
                                        {showRequesterDetails ? "View less" : "View more"}
                                    </button>
                                    {showRequesterDetails && (
                                        <div className="requester-details">
                                            <div style={{ color: 'gray', fontSize: '12px', fontWeight: '500' }}>Primary email</div>
                                            <span style={{ fontWeight: '500' }}>{ticketDetails?.requesterEmail}</span>
                                            <p className="recent-tickets">Recent tickets</p>
                                        </div>
                                    )}
                                </div>

                                <div className="properties-info">
                                    <h3>Properties</h3>
                                    <div className="property-details row">
                                        <div className="col-6">
                                            <label>Priority <span style={{ color: 'red' }}>*</span></label>
                                            <Select placeholder="Priority" value={formData.Priority} options={priorityOptions} style={{ width: '100%' }} onChange={(value) => setFormData({ ...formData, Priority: value })} />
                                        </div>
                                        <div className="col-6">
                                            <label>Status <span style={{ color: 'red' }}>*</span></label>
                                            <Select value={formData.Status} options={statusOptions} style={{ width: '100%' }} onChange={(value) => setFormData({ ...formData, Status: value })} />
                                        </div>
                                        <div className="col-6">
                                            <label>Source</label>
                                            <Select value={formData.Source} options={sourceOptions} style={{ width: '100%' }} onChange={(value) => setFormData({ ...formData, Source: value })} />
                                        </div>
                                        <div className="col-6">
                                            <label>Urgent</label>
                                            <Select value={formData.Urgency} options={priorityOptions} style={{ width: '100%' }} onChange={(value) => setFormData({ ...formData, Urgency: value })} />
                                        </div>
                                        <div>
                                            <label>Impact</label>
                                            <Select value={formData.Impact} options={priorityOptions} style={{ width: '100%' }} onChange={(value) => setFormData({ ...formData, Impact: value })} />
                                        </div>
                                        <div>
                                            <label>Property</label>
                                            <Select
                                                className="landingPageSearchs mr-2"
                                                mode="single"
                                                showSearch
                                                placeholder="Search for Property"
                                                labelInValue
                                                value={addressLabel}
                                                filterOption={false}
                                                onSearch={debounceFetcher}
                                                notFoundContent={fetching ? <Spin size="small" /> : null}
                                                options={options}
                                                onChange={handleSearchProperty}
                                                allowClear
                                                onClear={handleClearProperty}
                                            />
                                        </div>
                                        <div >
                                            <label>Agent</label>
                                            <Select value={formData.AssignTo} options={dpdata.map(item => ({
                                                label: item.text,
                                                value: item.value,
                                                disabled: item.disabled
                                            }))} style={{ width: '100%' }}
                                                onChange={(value) => setFormData({ ...formData, AssignTo: value })}
                                            />
                                        </div>
                                    </div>
                                    <button className="update-btn" onClick={submitProperties}>Update</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceManagement;